import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExamDetailsGrid from "./ExamDetailsGrid";
import { attendedExamsColumns, eligibleExamsColumns } from "./constants";
import { useParams } from "react-router-dom";
import CertificatesOfStudent from "./CertificatesOfStudent";

function StudentProfile() {
  const { studentId } = useParams();

  const [isCertificatesEnabled, setIsCertificatesEnabled] = useState(false);
  const [cgpa, setCGPA] = useState(null);
  const [totalCreditsObtained, setTotalCreditsObtained] = useState(0);
  const [isAllSemestersCompleted, setIsAllSemestersCompleted] = useState(false);
  

  const studentDetails = {
    studentName: "John Doe",
    rollNumber: studentId,
    email: "<EMAIL>",
    gender: "Male",
    college: "XYZ University",
    branch: "Computer Science",
    course: "B.Tech",
    eligibleExams: [
      {
        id: 1,
        exam: "Chemistry Final",
        exam_code: "CHEM303",
        batch: "Batch C",
        semester: "Summer",
        examtype: "Final",
        any: "Other data",
        month: "June",
        year: 2024,
        Type: "Type C",
      },
      {
        id: 2,
        exam: "Biology Midterm",
        exam_code: "BIO101",
        batch: "Batch D",
        semester: "Winter",
        examtype: "Midterm",
        any: "More data",
        month: "December",
        year: 2024,
        Type: "Type D",
      },
    ],
    attendedExams: [
      {
        id: 1,
        exam: "Math Final",
        exam_code: "MATH101",
        batch: "Batch A",
        semester: "Spring",
        examtype: "Final",
        any: "Any data",
        month: "March",
        year: 2023,
        Type: "Type A",
      },
      {
        id: 2,
        exam: "Physics Midterm",
        exam_code: "PHY202",
        batch: "Batch B",
        semester: "Fall",
        examtype: "Midterm",
        any: "Some data",
        month: "October",
        year: 2023,
        Type: "Type B",
      },
    ],

    semesterWiseInfo: {
      semester1: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 1", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 2", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        // Add more subjects for semester 1
        
      ],
      
      
      semester2: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 3", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 4", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
      ],

      semester3: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 5", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 6", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
      ],

      semester4: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 7", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 8", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
      ],

      semester5: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 9", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 10", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
      ],

      semester6: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 11", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 12", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3},
      ],

      semester7: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 13", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 14", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
      ],

      semester8: [
        { id: 1, subjectCode: "SUB1", subjectName: "Subject 15", gradeSecured :"B", gradePoint: 8, passFailStatus: "Pass",creditsObtained: 3 },
        { id: 2, subjectCode: "SUB2", subjectName: "Subject 16", gradeSecured :"B", gradePoint: 8, passFailStatus: "fail",creditsObtained: 3 },
      ],
      // Add data for semester 3 to semester 8
    },
  };

  // Calculate SGPA for each semester
  const calculateSGPA = (subjects) => {
    let totalCredits = 0;
    let totalGradePoints = 0;
    let hasFailedSubject = false;

    subjects.forEach((subject) => {
      totalCredits += subject.creditsObtained;
      totalGradePoints += subject.creditsObtained * subject.gradePoint;
      if (subject.passFailStatus === "Fail") {
        hasFailedSubject = true;
      }
    });

    if (hasFailedSubject) {
      return "Fail";
    }

    const sgpa = (totalGradePoints / totalCredits).toFixed(2);
    return sgpa;
  };

  useEffect(() => {
    // Calculate CGPA based on all semesters
    const semesters = Object.values(studentDetails.semesterWiseInfo);
    let totalGradePoints = 0;
    let totalCredits = 0;
    let hasFailedSubject = false;

    semesters.forEach((semester) => {
      const sgpa = calculateSGPA(semester);
      if (sgpa === "Fail") {
        hasFailedSubject = true;
      }
      const semesterCredits = semester.reduce((acc, subject) => acc + subject.creditsObtained, 0);
      totalGradePoints += parseFloat(sgpa) * semesterCredits;
      totalCredits += semesterCredits;
    });

    const calculatedCGPA = (totalGradePoints / totalCredits).toFixed(2);
    setCGPA(calculatedCGPA);
    setTotalCreditsObtained(totalCredits);

    // Check if all 8 semesters have been completed
    if (Object.keys(studentDetails.semesterWiseInfo).length === 8 && !hasFailedSubject) {
      setIsAllSemestersCompleted(true);
    }

    // Check if CGPA is displayed and all semesters are completed
    if (calculatedCGPA && isAllSemestersCompleted) {
      setIsCertificatesEnabled(true);
    }
  }, [studentDetails]);

  

  // Define semester-wise columns configuration
  const semesterWiseColumns = [
  { field: "subjectCode", headerName: "Subject Code", width: 200 },
  { field: "subjectName", headerName: "Subject Name", width: 200 },
  { field: "gradeSecured", headerName: "Grade Secured", width: 200 },
  { field: "gradePoint", headerName: "Grade Point", width: 200 },
  { field: "creditsObtained", headerName: "Credits Obtained", width: 200 },
  { field: "passFailStatus", headerName: " Status", width: 200 },
  
  
];

const attendedExamsData = studentDetails.attendedExams;
  const eligibleExamsData = studentDetails.eligibleExams;

  return (
    <Box sx={{ padding: "20px", backgroundColor: "#f0f0f0", borderRadius: "5px" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
        <Box>
          <Typography variant="h4">{studentDetails.studentName}</Typography>
          <Typography variant="subtitle1">Roll Number: {studentDetails.rollNumber}</Typography>
        </Box>
        <Avatar alt="Student Avatar" src="/avatar.jpg" sx={{ width: 120, height: 120 }} />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginTop: "30px",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body1">College: {studentDetails.college}</Typography>
        <Typography variant="body1">Course: {studentDetails.course}</Typography>
        <Typography variant="body1">Branch: {studentDetails.branch}</Typography>
      </Box>
      <CertificatesOfStudent
        styles={{
          marginBottom: "30px",
          marginTop: "30px",
          display: "flex",
          justifyContent: "end",
        }}
        isCertificatesEnabled={isCertificatesEnabled}
      />

      <Accordion sx={{ marginBottom: "20px" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Eligible Exams</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ExamDetailsGrid rows={eligibleExamsData} columns={eligibleExamsColumns} />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Attended Exams</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ExamDetailsGrid rows={attendedExamsData} columns={attendedExamsColumns} />
        </AccordionDetails>
      </Accordion>
      {/* Semester-wise information */}
      {Object.entries(studentDetails.semesterWiseInfo).map(([semester, subjects], index) => (
        <Box key={index} sx={{ marginTop: "20px", backgroundColor: "#f8f8f8", borderRadius: "5px", padding: "15px" }}>
          <Typography variant="h6">{`Semester ${index + 1}`}</Typography>
          <Box sx={{ overflowX: "auto", marginTop: "10px", backgroundColor: "#ffffff", borderRadius: "5px" }}>
            <ExamDetailsGrid rows={subjects} columns={semesterWiseColumns} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
            <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
              <span>{`Course Registered: ${subjects.length}`}</span>
              <span>{`Course Appeared: ${attendedExamsData.length}`}</span>
              <span>{`Passed: ${subjects.filter(subject => subject.passFailStatus === "Pass").length}`}</span>
              <span>{`Total Credits: ${subjects.reduce((acc, subject) => acc + subject.creditsObtained, 0)}`}</span>
            </Typography>
            <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
              <span style={{ fontWeight: "bold" }}>{`SGPA: ${calculateSGPA(subjects)}`}</span>
            </Typography>
          </Box>
        </Box>
      ))}
      {/* Display CGPA at the end */}
      <Box sx={{ marginTop: "20px", backgroundColor: "#ffffff", borderRadius: "5px", padding: "15px" }}>
        <Typography variant="h6">Overall Performance</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
          <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
            <span>{`Total Credits: ${totalCreditsObtained}`}</span>
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
            <span style={{ fontWeight: "bold" }}>{`CGPA: ${cgpa}`}</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default StudentProfile;

